import { Heading } from '@utilitywarehouse/hearth-react';
import clsx from 'clsx';

import { FAQLink } from './FAQLink';
import { Section } from './Section';
import { getIdsFromSlug } from './controlledAccordionState';
import './styles.scss';
import { FAQProps, FAQSection, FAQTopic } from './types';

const getSectionState = (id: string, expandedState: string[] | undefined) => {
  if (!expandedState) {
    return [];
  }
  return expandedState.reduce<string[]>((expandedTopics, slug) => {
    const { sectionId } = getIdsFromSlug(slug);
    return sectionId !== id ? expandedTopics : [...expandedTopics, slug];
  }, []);
};

const FAQ = <T extends string, P extends string>({
  sections,
  onAccordionChange,
  // expandedState is the external state prop for managing topic expansion from outside the component.
  expandedState,
  showTitle = true,
  embed = false,
  ref,
}: FAQProps<T, P>) => (
  <section
    className={clsx('faq__wrapper', {
      ['faq__wrapper--embed']: embed,
    })}
    ref={ref}
  >
    <div
      className={clsx({
        wrapper: !embed,
      })}
    >
      <div className="faq__content">
        {showTitle && (
          <Heading className="faq__title" size="lg" as="h2">
            FAQs
          </Heading>
        )}
        {sections.map(({ title, topics, id }) => (
          <Section
            key={id}
            sectionId={id}
            title={title}
            topics={topics}
            onAccordionChange={onAccordionChange}
            expandedState={getSectionState(id, expandedState)}
          />
        ))}
      </div>
    </div>
  </section>
);

export { FAQ, FAQLink };
export type { FAQSection, FAQTopic };
